import React from "react";
 
const Message = props => {
  return (
<div id="popup1" class="overlay_cus">
	<div class="message_popup_loading">
		<h3>Network Problem</h3>
		{/* <a class="close hand" onClick={props.handle_message}>&times;</a> */}
		<div class="content text-center mt-5">
            Unable to get the payload information from the serer.</div>
		<div class="text-center mt-2">
		<button type="button" class="btn close_btn size_12 font_fam mt-4" onClick={props.handle_message}>CLOSE </button>
		</div>
	</div>
</div>
  );
};
 
export default Message;